export interface AlertGroup {
  id: string
  gid: string
  deviceId: string
  deviceLocation: string
  priorityTier: number | null
  status: AlertStatus
  startAlertTime: string
  endAlertTime: string
  startAlertTimeUTC: string
  endAlertTimeUTC: string
  alertCloseDate?: string
  alerts: Alert[]
  triggerType: string
  hourlyAlertsSentDate: string
  dlId: number
  dUUID: string
  ackBy?: string
  estimatedLeakTotal: number
  deviceUom?: string
}

export interface Alert {
  id: number
  time: string
  utc_time: string
  createdAt: string
  priorityTier: number | null
  alert_score: number
  status: AlertStatus
  triggerType: string
  actioned: boolean
  ackBy?: string
  estimatedLeak: number
  valid: boolean
  excludeUsage?: boolean
  gid: string
  hourlyAlertsSent: HourlyAlertSent
}

interface HourlyAlertSent {
  action_type: number
  sent_at: string
  user_id_ref: number
}

export interface HistoricalAlertTier {
  gid: string
  closed_date: string
  start_date: string
  end_date: string
}

export interface HistoricalAlert {
  deviceId: string
  dlId: number
  dUUID: string
  tier1: HistoricalAlertTier[]
  tier2: HistoricalAlertTier[]
  tier3: HistoricalAlertTier[]
  tier1Total: number
  tier2Total: number
  tier3Total: number
  total: number
}

export enum AlertStatus {
  OPEN,
  IN_PROGRESS,
  CLOSED,
}

export interface AlertStat {
  ackt_result: number
  alert_count: number
}

export interface AlertStats {
  [key: string]: AlertStat[]
}

export interface AlertQuery {
  startDate?: string
  endDate?: string
  ackResult: number[]
}

export interface Stats {
  tier1Total: number
  tier2Total: number
  tier3Total: number
  totalAll: number
}

export interface StatsDevices extends Stats {
  devices: {
    deviceId: string
    deviceName: string
    tier1: number
    tier2: number
    tier3: number
    total: number
  }[]
}

export interface AlertAPI {
  created_at: string
  updated_at: string
  id: number
  ack_date: string | null
  ack_result: number | null
  closed_date: string | null
  device_id: string
  dl_id: number
  d_uuid: string
  device_location: string
  device_name: string
  timezone_time: string
  status: string
  hourly_alerts_sent: {
    user_id_ref: number
    alert_id_ref: number
    device_id_ref: number
    template_id: string
    mail_content: {
      alert_tier : number
      contact_name: string
      device_name: string
      liters_hour: string
    }
    sent_at: string
    action_type: number
  }
  hourly_alerts_sent_date: string | null
  valid: boolean
  gid: string
  alert_time_utc: string
  alert_time: string
  ack_by: string | null
  actioned: false
  alert_sent: boolean
  alert_score: number
  trigger_type: string
  estimated_leak: number
}


export interface HistoricalAlertGroupApi {
  ack_result: number
  alert_count: number
  groups: {
    gid: string
    closed_date: string
    start_date: string
    end_date: string
  }[]
}

export interface HistoricalAlertsApi {
  d_uuid: string
  dl_id: number
  device_id: string
  alerts: HistoricalAlertGroupApi[]
  total: number
}